@if (!isDWApp) {
  @if (!isProd) {
    <app-navbar></app-navbar>
  }
  @let disable = disablePage$ | async;
  <!-- Loading container for displaying the loading spinner and messages -->
  @if (disable && !isDWApp) {
    <div class="loading-container">
      <div class="loading-content">
        <!-- Loading spinner with conditions to stop spinning and fade-out -->
        <div
          class="loading-spinner mb-3"
          [ngClass]="{ 'fade-out': (disablePage$ | async) === false, 'stop-spin': stopSpinner$ | async }"
        ></div>
        <!-- Loading text based on conditions -->
        @if ((stopSpinner$ | async) === false) {
          <div>
            <p class="loading-text" [ngClass]="{ 'fade-out': (disablePage$ | async) === false }">
              Loading CI Platform data...
            </p>
          </div>
        }
        @if (stopSpinner$ | async) {
          <div>
            @if ((noConfigData$ | async) === false) {
              <div>
                @if (!hasError) {
                  <p class="loading-text">Sorry, your URL seems to be incomplete...</p>
                } @else {
                  <p class="loading-text">Sorry, error occurred</p>
                }
              </div>
            }
            @if (noConfigData$ | async) {
              <div>
                <p class="loading-text">Sorry, config data can't be loaded...</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Fieldset to disable/blur the content based on the disablePage condition -->
  @if ((disablePage$ | async) === false) {
    <fieldset [ngClass]="{ blur: disablePage$ | async, 'no-blur': (disablePage$ | async) === false }">
      <router-outlet></router-outlet>
    </fieldset>
  }
} 
@else{
   <app-dt></app-dt>
}
